// Contact.js
import React, { useEffect, useState } from 'react';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

export default function Contact() {
  const [init, setInit] = useState(false);

  // This should be run only once per application lifetime
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = (container) => {
    console.log("Contact particles loaded", container);
  };

  const options = {
    background: {
      color: {
        value: "transparent",
      },
    },
    fullScreen: { 
      enable: false
    },
    fpsLimit: 60,
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "grab",
        },
        resize: true,
      },
      modes: {
        grab: {
          distance: 140,
          links: {
            opacity: 0.5
          }
        },
      },
    },
    particles: {
      color: {
        value: "#ffffff",
      },
      links: {
        color: "#ffffff",
        distance: 150,
        enable: true,
        opacity: 0.2,  // Slightly more subtle for contact section
        width: 1,
      },
      move: {
        direction: "none",
        enable: true,
        outModes: {
          default: "bounce",
        },
        random: false,
        speed: 0.8,  // Slightly slower movement
        straight: false,
      },
      number: {
        density: {
          enable: true,
          area: 800,
        },
        value: 60,  // Fewer particles
      },
      opacity: {
        value: 0.4,  // Slightly more transparent
      },
      shape: {
        type: "circle",
      },
      size: {
        value: { min: 1, max: 3 },
      },
    },
    detectRetina: true,
  };

  return (
    <div id="contact-section" className="py-5 bg-dark text-white position-relative" style={{ overflow: 'hidden' }}>
      {/* Container for particles */}
      {init && (
        <div className="particles-container" style={{ 
          position: 'absolute', 
          left: 0, 
          top: 0, 
          width: '100%', 
          height: '100%', 
          overflow: 'hidden',
          pointerEvents: 'none'
        }}>
          <Particles
            id="contact-particles"
            className="particles-canvas"
            particlesLoaded={particlesLoaded}
            options={options}
          />
        </div>
      )}
      
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 text-center">
            <h2 className="mb-3">📬 Contact</h2>
            <p className="lead">Let's connect to discuss how I can bring innovative solutions to your organization.</p>
            
            <div className="row mt-4">
              <div className="col-md-6 mb-3">
                <div className="card bg-dark border border-secondary">
                  <div className="card-body">
                    <h5 className="card-title"><i className="bi bi-envelope-fill me-2"></i> Email</h5>
                    <a href="mailto:jobs.efrahdz@gmail.com" className="text-info text-decoration-none">
                      jobs.efrahdz@gmail.com
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="card bg-dark border border-secondary">
                  <div className="card-body">
                    <h5 className="card-title"><i className="bi bi-linkedin me-2"></i> LinkedIn</h5>
                    <a href="https://www.linkedin.com/in/efraim-hernandez-a842431b0/" className="text-info text-decoration-none" target="_blank" rel="noopener noreferrer">
                      Connect on LinkedIn
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}